import React, {
  useState,
  useEffect,
  useCallback,
  useContext,
  useRef,
} from "react";
import "./Menu.scss";
import DeleteIcon from "@mui/icons-material/Delete";
import formatNumberWithCommas from "../format/formatNumberWithCommas";
import { AppContext } from "../../App";
import { sortProduct } from "../format/SortProduct";

const Menu = ({ selectedItemList, Clear }) => {
  const [open, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [orderList, setOrderList] = useState([]);
  const [inputNumber, setInputNumber] = useState(1);
  const [newPrice, setNewPrice] = useState("");
  const popupRef = useRef(null);
  const { dataProducts } = useContext(AppContext);

  const handleOpenMenu = () => {
    setOpen(true);
  };

  const handleCloseMenu = () => {
    setOpen(false);
    setSelectedItem(null);
  };

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setOpen(false);
      setInputNumber(1);
      setSelectedItem(null);
    }
  };

  const handleChangeInputNumber = (event) => {
    const value = parseInt(event.target.value);
    setInputNumber(value);
    // Update totalItem in selectedItem
    if (selectedItem) {
      setSelectedItem((prevSelectedItem) => ({
        ...prevSelectedItem,
        totalItem: value,
      }));
    }
  };

  const handleChangePrice = (event) => {
    const value = event.target.value;
    setNewPrice(value);
  };


  useEffect(() => {
    if (selectedItem && newPrice === "") {
      const calculatedPrice =
        newPrice !== "" ? parseFloat(newPrice) : parseFloat(selectedItem.price);
      setSelectedItem((prevSelectedItem) => ({
        ...prevSelectedItem,
        price: calculatedPrice,
      }));
    }
  }, [newPrice, selectedItem]);

  const handleClickItem = (name, price, _id) => {
    const calculatedPrice =
      newPrice !== "" ? parseFloat(newPrice) : parseFloat(price);
    setSelectedItem({
      name,
      totalItem: inputNumber,
      price: calculatedPrice,
      _id,
    });
  };

  const addItemInOrderList = useCallback(() => {
    if (!selectedItem) {
      console.error("No item selected");
      return;
    }

    const updatedPrice =
      newPrice !== ""
        ? parseFloat(newPrice + "000")
        : parseFloat(selectedItem.price);

    const existingItemIndex = orderList.findIndex(
      (item) => item._id === selectedItem._id
    );

    if (existingItemIndex !== -1) {
      const updatedOrderList = orderList.map((item) => {
        if (item._id === selectedItem._id) {
          return {
            ...item,
            totalItem:
              parseInt(item.totalItem) + parseInt(selectedItem.totalItem),
            totalPrice:
              updatedPrice *
              (parseInt(item.totalItem) + parseInt(selectedItem.totalItem)),
            price: updatedPrice,
          };
        }
        return item;
      });
      setOrderList(updatedOrderList);
    } else {
      const newItem = {
        ...selectedItem,
        totalPrice: updatedPrice * parseInt(selectedItem.totalItem),
        price: updatedPrice, // Update the price here
      };

      setOrderList([...orderList, newItem]);
    }

    setSelectedItem(null);
    setInputNumber(1);
    setNewPrice("");
  }, [selectedItem, orderList, newPrice]);

  const removeItemFromOrderList = (_id) => {
    const updatedOrderList = orderList.filter((item) => item._id !== _id);
    setOrderList(updatedOrderList);
  };

  useEffect(() => {
    selectedItemList(orderList);
  }, [orderList, selectedItemList]);

  useEffect(() => {
    if (Clear === true) {
      setSelectedItem(null);
      setOrderList([]);
      setNewPrice("");
    }
  }, [Clear]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const sortedProductData = sortProduct(dataProducts);

  return (
    <div>
      <button onClick={handleOpenMenu} className="button-add button-app">
        Menu
      </button>

      {open && (
        <div className="dark-screen">
          <div className="frame-menu" ref={popupRef}>
            <div className="fram-top-menu">
              <div className="frame-button-close">
                <span>Menu</span>
                <button onClick={handleCloseMenu}>X</button>
              </div>
              <div className="frame-action-menu">
                <div className="frame-name-number-add">
                  <div className="frame-name-action">
                    <div>
                      <h3>Tên Sản Phẩm :</h3>
                    </div>
                    <div className="frame-name">
                      <h3>{selectedItem && selectedItem.name}</h3>
                    </div>
                  </div>

                  <div className="frame-inputnumber-additem">
                    <input
                      onChange={handleChangeInputNumber}
                      type="number"
                      value={inputNumber}
                      min="1"
                    />
                    <button
                      onClick={addItemInOrderList}
                      className="button-add-item"
                    >
                      {" "}
                      Thêm{" "}
                    </button>
                  </div>
                </div>

                <div className="frame-newPrice">
                  <div>
                    <h3>Giá Mới :</h3>
                  </div>

                  <div className="frame-input">
                    <input
                      placeholder="Giá Mới"
                      onChange={handleChangePrice}
                      value={newPrice}
                      type="number"
                      className="input-new-price"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="frame-item">
              <div className="frame-item-map">
                {sortedProductData.map((item) => (
                  <div
                    className="item-map"
                    key={item._id}
                    onClick={() =>
                      handleClickItem(item.name, item.price, item._id)
                    }
                  >
                    {item.image && <img src={item.image} alt={item.name} />}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="frame-orderlist">
        <table>
          <thead>
            <tr>
              <th>Tên</th>
              <th>Giá</th>
              <th>Số Lượng</th>
              <th>Tổng</th>
              <th>Xóa </th>
            </tr>
          </thead>

          {orderList.length > 0 && (
            <tbody className="scrollable-tbody">
              {orderList.map((item, index) => (
                <tr key={index}>
                  <td>{item.name}</td>
                  <td>{formatNumberWithCommas(item.price)}</td>
                  <td>{formatNumberWithCommas(item.totalItem)}</td>
                  <td>{formatNumberWithCommas(item.totalPrice)}</td>
                  <td>
                    <button
                      className="button-remove-item"
                      onClick={() => removeItemFromOrderList(item._id)}
                    >
                      <DeleteIcon className="iconDelete" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          )}
        </table>
      </div>
    </div>
  );
};

export default Menu;
